module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Country":"Pays"},"fr":{"Country":"Pays"}}')
  delete Component.options._Ctor
}
